import React from 'react';
import { BusyIndicatorSize } from '@ui5/webcomponents-react';
import { Loading } from 'components/shared/Loading';
import { UnableLoadUserInfoPage } from 'components/shared/UnableLoadUserInfoPage/UnableLoadUserInfoPage';
import { useGetUserInfoQuery } from 'generated/graphql';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './msalConfig';

interface AuthorizationGuardProps {
  children: React.ReactNode;
}

export const AuthorizationGuard: React.FC<AuthorizationGuardProps> = ({ children }) => {
  const [user] = useGetUserInfoQuery();
  const { instance } = useMsal();

  if (user.fetching) {
    return <Loading size={BusyIndicatorSize.Large} />;
  } else if (user.error) {
    const account = instance.getActiveAccount();
    if (user.error.graphQLErrors[0].message === 'cannot verify token' && account) {
      instance.acquireTokenRedirect({
        ...loginRequest,
        account
      });
    } else {
      return <UnableLoadUserInfoPage />;
    }
  }
  return <>{children}</>;
};
